import {
  Component,
  OnInit,
  HostListener,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DrawerService } from '../../shared/services/drawer.service';
import { ProfileService } from '../../shared/services/profile.service';
import { CommonModule } from '@angular/common';
import { TokenClaimsService } from '../../shared/services/token-claims.service';
import { PageHeaderService } from 'src/app/shared/services/page-header.service';
import { Router } from '@angular/router';
import { BreakpointService } from '../services/breakpoint.service';

@Component({
  selector: 'app-page-header',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatSidenavModule,
    CommonModule,
  ],
  template: `
    <div class="header">
      <mat-toolbar [ngClass]="{ 'mobile-styling': isMobile }">
        <span class="spacer"></span>
        @if (!isMobile) {
          <span> {{ profile.profile$().displayName }} </span>
        }
        <button
          class="account-button"
          mat-icon-button
          type="button"
          [matMenuTriggerFor]="menu"
          aria-label="Account button"
        >
          <mat-icon
            aria-hidden="false"
            aria-label="User Account"
            [fontIcon]="icons.account"
          ></mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="toggleSettings('Settings')">
            Settings
          </button>
          @if (canAccessUserManagement()) {
            <button (click)="loadUserManagement()" mat-menu-item>
              User Management
            </button>
          }
          @if (canAccessAdmin()) {
            <button (click)="loadAdminSupport()" mat-menu-item>Admin</button>
          }
          @if (isQBuiltHomeOffice) {
            <button (click)="uploadCSV()" mat-menu-item>
              QBuilt File Upload
            </button>
          }
        </mat-menu>
      </mat-toolbar>
    </div>
  `,
  styles: [
    `
      .header {
        z-index: 1;
        position: relative;
        width: 100%;
        //box-shadow: var(--box-shadow);
      }

      .spacer {
        flex: 1 1 auto;
      }

      .mobile-styling {
        background-color: transparent;

        .mat-icon {
          color: white;
        }
      }
    `,
  ],
})
export class PageHeaderComponent implements OnInit {
  private pageHeaderSrv = inject(PageHeaderService);
  private router = inject(Router);
  public settingsDrawer = inject(DrawerService);
  public profile = inject(ProfileService);
  private breakPointService = inject(BreakpointService);
  private tokenClaimsSrv = inject(TokenClaimsService);

  icons = {
    account: 'account_circle',
    theme: 'light_mode',
  };
  isAdmin = toSignal(this.pageHeaderSrv.isAdmin$, { initialValue: false });
  isSupport = toSignal(this.pageHeaderSrv.isSupport$, { initialValue: false });
  canAccessUserManagement = computed(() => this.isAdmin() || this.isSupport());
  canAccessAdmin = computed(() => this.isAdmin());
  isQBuiltHomeOffice: boolean;

  //mobile settings
  isMobile = false;
  public getScreenWidth: number;
  public getScreenHeight: number;

  //listens for a screen size change for displaying nav-bar or nav-bar-mobile
  @HostListener('window:resize')
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    this.isMobile = this.breakPointService.mobileCheck(
      this.getScreenHeight,
      this.getScreenWidth,
    );
  }

  ngOnInit(): void {
    this.isQBuiltHomeOffice = this.tokenClaimsSrv.canAccessHomeOfficeAdmin;
    //check screen size for nav-bar
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    this.isMobile = this.breakPointService.mobileCheck(
      this.getScreenHeight,
      this.getScreenWidth,
    );
  }

  toggleSettings(heading: string) {
    this.settingsDrawer.heading = heading;
    this.settingsDrawer.state.update((value: boolean) => !value);
  }

  loadUserManagement() {
    this.router.navigate(['administration/users']);
  }

  loadAdminSupport() {
    this.router.navigate(['administration/support']);
  }

  //allows user to upload a CSV file for Qbuilt items
  uploadCSV() {
    this.router.navigate(['administration/csv-file-upload']);
  }
}
